import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/icon/Icon';

interface SubscriptionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    currentPlan: string;
    newPlan: string;
    currentPrice: string;
    newPrice: string;
    isPriceIncrease: boolean;
}

const SubscriptionModal: React.FC<SubscriptionModalProps> = ({
    isOpen,
    onClose,
    onConfirm,
    currentPlan = '',
    newPlan = '',
    currentPrice = '$0',
    newPrice = '$0',
    isPriceIncrease = false
}) => {
    if (!isOpen) return null;

    const renderTitle = () => {
        // Currently only supporting upgrades
        return "Confirm Plan Upgrade";
        
        /* Future implementation for downgrades
        if (isPriceIncrease) {
            return "Confirm Plan Upgrade";
        }
        return "Confirm Plan Change";
        */
    };

    const renderMessage = () => {
        // Currently only supporting upgrades
        return (
            <>
                <p className="mb-4">
                    You are about to upgrade from <span className="font-semibold">{currentPlan || 'Free Plan'}</span> ({currentPrice || '$0'}) to <span className="font-semibold">{newPlan}</span> ({newPrice}).
                </p>
                <p className="mb-6">
                    Your card will be charged immediately for the prorated amount, and your billing cycle will remain the same.
                </p>
            </>
        );
        
        /* Future implementation for downgrades
        if (isPriceIncrease) {
            return (
                <>
                    <p className="mb-4">
                        You are about to upgrade from <span className="font-semibold">{currentPlan}</span> ({currentPrice}) to <span className="font-semibold">{newPlan}</span> ({newPrice}).
                    </p>
                    <p className="mb-6">
                        Your card will be charged immediately for the prorated amount, and your billing cycle will remain the same.
                    </p>
                </>
            );
        }
        
        return (
            <>
                <p className="mb-4">
                    You are about to change from <span className="font-semibold">{currentPlan}</span> ({currentPrice}) to <span className="font-semibold">{newPlan}</span> ({newPrice}).
                </p>
                <p className="mb-6">
                    This change will take effect immediately, and your billing cycle will be adjusted accordingly.
                </p>
            </>
        );
        */
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="relative w-full max-w-lg rounded-lg bg-white p-6 shadow-lg">
                <div className="absolute right-4 top-4">
                    <button
                        className="text-gray-400 hover:text-gray-600"
                        onClick={onClose}
                    >
                        <Icon icon="HeroXMark" className="h-5 w-5" />
                    </button>
                </div>
                
                <div className="mb-4 flex items-center">
                    <Icon icon="HeroArrowUp" className="mr-2 h-6 w-6 text-indigo-600" />
                    
                    {/* Future implementation for different icons based on plan change type
                    {isPriceIncrease ? (
                        <Icon icon="HeroArrowUp" className="mr-2 h-6 w-6 text-indigo-600" />
                    ) : (
                        <Icon icon="HeroArrowsRightLeft" className="mr-2 h-6 w-6 text-blue-600" />
                    )}
                    */}
                    <h3 className="text-xl font-bold">{renderTitle()}</h3>
                </div>
                
                <div className="py-2">
                    {renderMessage()}
                    
                    <div className="mb-4 rounded-lg bg-gray-50 p-4">
                        <h4 className="mb-2 font-medium">Important Information:</h4>
                        <ul className="list-inside list-disc text-sm text-gray-600">
                            <li>Your subscription will update immediately</li>
                            <li>You'll have immediate access to new plan features</li>
                            <li>Your payment method on file will be charged</li>
                        </ul>
                    </div>
                </div>
                
                <div className="flex justify-end space-x-3">
                    <Button
                        variant="outline"
                        color="zinc"
                        onClick={onClose}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="solid"
                        color="blue"
                        colorIntensity="600"
                        icon="HeroArrowUpCircle"
                        onClick={onConfirm}
                    >
                        Upgrade Now
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SubscriptionModal; 